
import BaseMixin from '@/views/mixin.vue'
import { Icon, Button, Checkbox } from 'view-design';
import compSearch from './search';
import { HttpVsGroups } from '@/service/boss/dictionary'
export default {
    mixins: [BaseMixin],
    components: {
        compSearch,
    },
    data() {
        return {
            title: "",
            rowId: "",
        };
    },
    methods: {
        httpList: HttpVsGroups,
        getRowData() {
            return this.data[this.rowId] || {}
        }
    }, 
    computed: {
        columns() {
            return [
                {
                    width: 60,
                    render: (h, { row, index }) => {
                        return h('Radio', {
                            props: {
                                value: this.rowId === index
                            },
                            on: {
                                input: (event) => {
                                    this.rowId = index;
                                }
                            }
                        })
                    }
                },
                {
                    title: this.$t('fbb.warehouse.virtual_warehouse',{defaultValue:'虚拟仓'}),
                    key: 'name',
                },
                {
                    title: this.$t('global.common.project',{defaultValue:'项目'}),
                    key: 'lineId',
                    render: (h, { row }) => {
                        const id = row.lineId;
                        const product = this.getNewProductList.filter((item) => {
                            return id == item.value
                        })[0] || {};
                        return <span>{product.label}</span>
                    },
                }, {
                    title: 'ERP SKU',
                    key: 'erpSku',
                }, {
                    title: this.$t('erp.virtualstore.groupname',{defaultValue:'虚拟仓分组'}),
                    key: 'name',
                    render(h, { row }) {
                        const name = `${row.name}`.slice(0, -3),
                        goback = function () {
                            window.open('#/home/virtualstore/list?name=' + name)
                        };
                        return <a onClick={goback}>{name}</a>
                    },
                }
            ];
        },
    },
};




